module.exports = __webpack_public_path__ + "680784f2d1f885093dca6febf9e7f866.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/event-edit.png
// module id = 216
// module chunks = 0